import React, { useState, useEffect } from "react";

// Components
import Main from "./ReceiptVoucher/Main";
import Form from "./ReceiptVoucher/Form";

import {
    getDataWithComp,
    getDocStatusColour,
    getAlert,
    getMaxDocNo, // Assuming generic or I'll implement getMaxRcvNo
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";
import Navbar from "../../components/Modal/Navbar";

function ReceiptVoucher() {
    const [mode, setMode] = useState("");
    const [dataMasterList, setDataMasterList] = useState([]);
    const [dataDetailList, setDataDetailList] = useState([]);
    const [statusColours, setStatusColours] = useState([]);
    const [maxRcvNo, setMaxRcvNo] = useState();

    useEffect(() => {
        initialize();
    }, []);

    const fetchRealtime = async () => {
        try {
            // Using RCV_H table directly as I don't know if API_RCV_H exists
            const masterList = await getDataWithComp(
                "RCV_H",
                "ORDER BY Rcv_No DESC"
            );

            // Status colors - assuming similar setup or default
            // const payStatusColour = await getDocStatusColour("RCV", "Rcv_Status");

            if (masterList && masterList.length > 0) {
                const sortedData = masterList.sort((a, b) => a.Rcv_No - b.Rcv_No);
                setDataMasterList(sortedData);
            }

            // if (payStatusColour && payStatusColour.length > 0) {
            //   setStatusColours(payStatusColour);
            // }

            // Find Max RcvNo
            const findMaxRcvNo = await getDataWithComp(
                "RCV_H",
                "ORDER BY Rcv_No DESC"
            );
            // Assuming getMaxDocNo or similar utility exists, or implementing simple logic
            const maxRcv = findMaxRcvNo.length > 0 ? findMaxRcvNo[0].Rcv_No : "";
            setMaxRcvNo(maxRcv);
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const initialize = async () => {
        try {
            setMode("S");
            fetchRealtime();
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const onPageInsert = () => {
        setMode("I");
    };

    const onRowSelected = (rcvNo) => {
        setMaxRcvNo(rcvNo);
        setMode("U");
    };

    return (
        <div className="ReceiptVoucher">
            <div className="wrapper">
                <Navbar />
                <div className="main-panel">
                    <div className="container">
                        <div className="page-inner">
                            {mode === "S" ? (
                                <Main
                                    masterList={dataMasterList}
                                    detailList={dataDetailList}
                                    statusColours={statusColours}
                                    name={"ใบสำคัญรับ"}
                                    onPageInsert={() => onPageInsert()}
                                    onRowSelected={(rcvNo) => onRowSelected(rcvNo)}
                                    getReport={getReport}
                                />
                            ) : (
                                <Form
                                    callInitialize={initialize}
                                    mode={mode}
                                    name={"ใบสำคัญรับ"}
                                    maxRcvNo={maxRcvNo}
                                    getReport={getReport}
                                    masterList={dataMasterList}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReceiptVoucher;
